<template>
    <div>
        <Header></Header>
        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-if="activeTabIs=='editPersonalSettings'||activeTabIs=='changePassword'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     {{$ml.get('PERSONAL_SETTINGS')}}
                </div>
            </div>  
        </div>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-if="activeTabIs=='generalCompanySettings'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     {{$ml.get('COMPANY_SETTINGS')}}
                </div>
            </div>  
        </div>
        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-if="activeTabIs=='calendarManagement'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     {{$ml.get('CALENDAR_MANAGEMENT')}}
                </div>
            </div>  
        </div>
        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-if="activeTabIs=='teklifSablonlariSettings'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     {{$ml.get('OFFER_TEMPLATES')}}
                </div>
            </div>  
        </div>
        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-if="activeTabIs=='documentManagementSettings'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     {{$ml.get('DOCUMENT_MANAGEMENT')}}
                </div>
            </div>  
        </div>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-else-if="activeTabIs=='customFieldsSettings'">
            <div class="container pl-0 d-flex justify-content-between">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     {{$ml.get('ADD_SPEACIAL_AREA')}}
                </div>
                <div class="align-self-center">
                    <button type="button" class="btn bg-new-primary py-1 border-0" data-toggle="modal" data-target="#addCustomField" >
                        <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_SPEACIAL_AREA')}}
                    </button>  
                </div>
            </div>  
        </div>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv " v-else-if="activeTabIs=='emailSettings'">
            <div class="container pl-0 d-flex justify-content-between">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                    {{$ml.get('SETTINGS_EMAIL')}}
                </div>
                <div class="m-0 align-self-center f-12">
                    {{$ml.get('ACCOUNT_USER_NAME')}}
                    <div class="color-gray p-0">{{user.name}} {{user.surName}}</div>
                </div>
            </div>  
        </div>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv " v-else-if="activeTabIs=='userManagement'" >
            <div class="container pl-0 d-flex justify-content-between">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                    {{$ml.get('USER_MANAGEMENT')}}
                </div>
                 <div class="m-0 align-self-center f-12">
                    {{$ml.get('ACCOUNT_USER_NAME')}}
                    <div class="color-gray p-0">{{user.name}} {{user.surName}}</div>
                </div>
            </div>  
        </div>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-else-if="activeTabIs=='callCenterSettings'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     Çağrı Merkezi Ayarları
                </div>
            </div>  
        </div>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-else-if="activeTabIs=='backupPage'||activeTabIs=='restorePage'||activeTabIs=='auditPage'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     {{$ml.get('SECURITY_SETTINGS')}}
                </div>
            </div>  
        </div>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-else-if="activeTabIs=='thirdPartySettings'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                    3. Parti Yazılımlar
                </div>
            </div>  
        </div>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv" v-else-if="activeTabIs=='workflowManagement'">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                     {{$ml.get('WORKFLOW_AUTOMATION')}}
                </div>
            </div>  
        </div>

        <div class="container">
        <div v-if="windowWidth<992">
            <div class="row my-4 justify-content-between" v-if="activeTabIs=='editPersonalSettings'||activeTabIs=='changePassword'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    {{$ml.get('PERSONAL_SETTINGS')}}
                </div>
            </div>

            <div class="row my-4 justify-content-between" v-if="activeTabIs=='generalCompanySettings'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                   {{$ml.get('COMPANY_SETTINGS')}}
                </div>
            </div>

            <div class="row my-4 justify-content-between" v-else-if="activeTabIs=='customFieldsSettings'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    {{$ml.get('ADD_SPEACIAL_AREA')}}
                </div>
                <div class="align-self-center">
                    <button type="button" class="btn bg-new-primary f-14 h-100 w-100 text-left" data-toggle="modal" data-target="#addCustomField" >
                        <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_SPEACIAL_AREA')}}
                    </button>  
                </div>
            </div>

            <div class="row my-4 justify-content-between" v-else-if="activeTabIs=='userManagement'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    {{$ml.get('USER_MANAGEMENT')}}
                </div>
                <div class="align-self-center">
                    {{$ml.get('ACCOUNT_USER_NAME')}}
                    <div class="color-gray">{{user.name}} {{user.surName}}</div>
                </div>
            </div>

            <div class="row my-4 justify-content-between" v-else-if="activeTabIs=='emailSettings'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    {{$ml.get('SETTINGS_EMAIL')}}
                </div>
                <div class="align-self-center">
                    {{$ml.get('ACCOUNT_USER_NAME')}}
                    <div class="color-gray">{{user.name}} {{user.surName}}</div>
                </div>
            </div>

            <div class="row my-4 justify-content-between" v-else-if="activeTabIs=='callCenterSettings'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    Çağrı Merkezi Ayarları
                </div>
            </div>

            <div class="row my-4 justify-content-between" v-else-if="activeTabIs=='backupPage'||activeTabIs=='restorePage'||activeTabIs=='auditPage'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    {{$ml.get('SECURITY_SETTINGS')}}
                </div>
            </div>

            <div class="row my-4 justify-content-between" v-else-if="activeTabIs=='thirdPartySettings'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    3. Parti Yazılımlar
                </div>
            </div>

            <div class="row my-4 justify-content-between" v-else-if="activeTabIs=='workflowManagement'">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    {{$ml.get('WORKFLOW_AUTOMATION')}}
                </div>
            </div>
        </div>
         <!-- son -->
            <div class="row mt-5">
                <div v-if="windowWidth<maxMobilSize" class="d-block w-100 mb-3">
                    <div class="settingsMenuDropTitle" @click="toggleClick('settingsTabMenu')">
                        <span>{{$ml.get('SETTINGS_MENU')}}</span>
                        <i class="fas fa-chevron-down ml-3"></i>
                    </div> 
                </div>
                <div class="col-md-3 pl-0" style="display:grid;">
                    <div class="settigsLeftMenu">
                        <ul class="nav settingsMenu" id="settingsTabMenu" role="tablist"> 
                            <li class="w-100 text-center">
                                <div href="#personalSettings" data-target="#personalSettings" aria-expanded="true">
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        {{$ml.get('PERSONAL_SETTINGS')}}
                                    </button>  
                                </div>
                                <div class="collapse show" id="personalSettings" aria-expanded="true">
                                    <ul class="flex-column nav ">
                                        <li class="nav-item">
                                            <div id="editPersonalSettings-tab" :class="{active:activeTabIs=='editPersonalSettings'}" @click="setActiveTabAs('editPersonalSettings'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    {{$ml.get('EDIT_PERSONAL_SETTINGS')}}
                                                </button>  
                                            </div>
                                        </li>
                                        <li class="nav-item">
                                            <div id="changePassword-tab" :class="{active:activeTabIs=='changePassword'}" @click="setActiveTabAs('changePassword'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                     {{$ml.get('CHANGE_PASSWORD')}}
                                                </button>  
                                            </div>
                                        </li>
                                        <li class="nav-item">
                                            <div id="emailSettings-tab" :class="{active:activeTabIs=='emailSettings'}" @click="setActiveTabAs('emailSettings'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    {{$ml.get('SETTINGS_EMAIL')}}
                                                </button>  
                                            </div>
                                        </li>
                                        <li class="nav-item">
                                            <div id="calendarManagement-tab" :class="{active:activeTabIs=='calendarManagement'}" @click="setActiveTabAs('calendarManagement'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    {{$ml.get('CALENDAR_MANAGEMENT')}}
                                                </button>  
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li class="w-100 text-center">
                                <div href="#companySettings" data-toggle="collapse" data-target="#companySettings" aria-expanded="false">
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        {{$ml.get('COMPANY_SETTINGS')}}
                                    </button>  
                                </div>
                                <div class="collapse" :class="{show:activeTabIs=='documentManagementSettings'}" id="companySettings" aria-expanded="false">
                                    <ul class="flex-column nav ">
                                        <li class="nav-item" v-if="isRoleAdmin">
                                            <div id="generalCompanySettings-tab" :class="{active:activeTabIs=='generalCompanySettings'}" @click="setActiveTabAs('generalCompanySettings'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    {{$ml.get('GENERAL_COMPANY_SETTINGS')}}
                                                </button>  
                                            </div>
                                        </li>
                                        <li class="nav-item" v-if="isRoleAdmin">
                                            <div id="customFieldsSettings-tab" :class="{active:activeTabIs=='customFieldsSettings'}" @click="setActiveTabAs('customFieldsSettings'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    {{$ml.get('ADD_SPEACIAL_AREA')}}
                                                </button>   
                                            </div>
                                        </li>
                                        <li class="nav-item" v-if="isRoleAdmin">
                                            <div id="teklifSablonlari-tab" :class="{active:activeTabIs=='teklifSablonlariSettings'}" @click="setActiveTabAs('teklifSablonlariSettings'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    Teklif Şablonları
                                                </button>   
                                            </div>
                                        </li>
                                        <li class="nav-item" v-if="isRoleAdmin">
                                            <div id="documentManagement-tab" :class="{active:activeTabIs=='documentManagementSettings'}" @click="setActiveTabAs('documentManagementSettings'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    Dosya Yönetimi
                                                </button>   
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li class="w-100 text-center" v-if="isRoleAdmin">
                                <div  id="userManagement-tab"  :class="{active:activeTabIs=='userManagement'}" @click="setActiveTabAs('userManagement'), toggleClick('settingsTabMenu')">
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        {{$ml.get('USER_MANAGEMENT')}}
                                    </button>   
                                </div>
                            </li>
                            <li class="w-100 text-center">
                                <div  id="callCenterSettings-tab"  :class="{active:activeTabIs=='callCenterSettings'}" @click="setActiveTabAs('callCenterSettings'), toggleClick('settingsTabMenu')">
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        Çağrı Merkezi Ayarları
                                    </button>   
                                </div>
                            </li>
                            <li class="w-100 text-center" v-if="isRoleAdmin">
                                <div href="#securitySettings" data-toggle="collapse" data-target="#securitySettings">
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        {{$ml.get('SECURITY_SETTINGS')}}
                                    </button>  
                                </div>
                                <div class="collapse" id="securitySettings" aria-expanded="false">
                                    <ul class="flex-column nav ">
                                        <li class="nav-item">
                                            <div id="auditPage-tab" :class="{active:activeTabIs=='auditPage'}" @click="setActiveTabAs('auditPage'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    {{$ml.get('AUDIT_RECORD')}}
                                                </button>  
                                            </div>
                                        </li>
                                        <li class="nav-item">
                                            <div id="restorePage-tab" :class="{active:activeTabIs=='restorePage'}" @click="setActiveTabAs('restorePage'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                    {{$ml.get('RESTORE')}}
                                                </button>  
                                            </div>
                                        </li>
                                        <li class="nav-item">
                                            <div id="backupPage-tab" :class="{active:activeTabIs=='backupPage'}" @click="setActiveTabAs('backupPage'), toggleClick('settingsTabMenu')">
                                                <button type="button" class="btn bg-white f-14 h-100 w-100 text-left pl-4">
                                                     {{$ml.get('BACKUP')}}
                                                </button>  
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li class="w-100 text-center" v-if="isRoleAdmin">
                                <div  id="thirdPartySettings-tab"  :class="{active:activeTabIs=='thirdPartySettings'}" @click="setActiveTabAs('thirdPartySettings'), toggleClick('settingsTabMenu')">
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        3. Parti Yazılımlar
                                    </button>   
                                </div>
                            </li>
                            <li class="w-100 text-center dNoneMobil" v-if="isRoleAdmin">
                                <div  id="workflowManagement-tab"  :class="{active:activeTabIs=='workflowManagement'}" @click="setActiveTabAs('workflowManagement'), toggleClick('settingsTabMenu')">
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        {{$ml.get('WORKFLOW_AUTOMATION')}}
                                    </button>   
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-9 filter mb-2 p-0">
                    <div class="tab-content" id="settingsTabContent" style="min-height:200px">
                        <div class="tab-pane" :class="{show:activeTabIs=='editPersonalSettings',active:activeTabIs=='editPersonalSettings'}" role="tabpanel" aria-labelledby="tab-tab" id="editPersonalSettings">
                            <editPersonalSettings/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='changePassword',active:activeTabIs=='changePassword'}"  role="tabpanel" aria-labelledby="tab-tab" id="changePassword">
                            <changePassword/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='emailSettings',active:activeTabIs=='emailSettings'}" role="tabpanel" aria-labelledby="tab-tab" id="emailSettings">
                            <email-settings/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='calendarManagement',active:activeTabIs=='calendarManagement'}" role="tabpanel" aria-labelledby="tab-tab" id="calendarManagement">
                            <calendar-management/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='generalCompanySettings',active:activeTabIs=='generalCompanySettings'}" v-if="isRoleAdmin" role="tabpanel" aria-labelledby="tab-tab" id="generalCompanySettings">
                            <generalCompanySettings/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='customFieldsSettings',active:activeTabIs=='customFieldsSettings'}" v-if="isRoleAdmin"  role="tabpanel" aria-labelledby="tab-tab" id="customFieldsSettings">
                        <add-customField/>
                        </div>
                        
                        <div class="tab-pane" :class="{show:activeTabIs=='teklifSablonlariSettings',active:activeTabIs=='teklifSablonlariSettings'}" v-if="isRoleAdmin"  role="tabpanel" aria-labelledby="tab-tab" id="teklifSablonlariSettings">
                        <bid-templates/>
                        </div>

                        <div class="tab-pane" :class="{show:activeTabIs=='documentManagementSettings',active:activeTabIs=='documentManagementSettings'}" v-if="isRoleAdmin"  role="tabpanel" aria-labelledby="tab-tab" id="documentManagementSettings">
                        <document-management/>
                        </div>

                        <div class="tab-pane" :class="{show:activeTabIs=='userManagement',active:activeTabIs=='userManagement'}" role="tabpanel" aria-labelledby="tab-tab" id="userManagement">
                            <user-manager :user="user" :users="users" ref="usermanager" @getUsers="isActive"/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='callCenterSettings',active:activeTabIs=='callCenterSettings'}" role="tabpanel" aria-labelledby="tab-tab" id="callCenterSettings">
                            <callCenterSettings/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='thirdPartySettings',active:activeTabIs=='thirdPartySettings'}" role="tabpanel" aria-labelledby="tab-tab" id="thirdPartySettings">
                            <thirdPartySettings/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='auditPage',active:activeTabIs=='auditPage'}" v-if="isRoleAdmin" role="tabpanel" aria-labelledby="tab-tab" id="auditPage">
                            <auditRecord/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='restorePage',active:activeTabIs=='restorePage'}" v-if="isRoleAdmin" role="tabpanel" aria-labelledby="tab-tab" id="restorePage">
                            <systemRestore/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='backupPage',active:activeTabIs=='backupPage'}" v-if="isRoleAdmin" role="tabpanel" aria-labelledby="tab-tab" id="backupPage">
                            <downloadBackup/>
                        </div>
                        <div class="tab-pane" :class="{show:activeTabIs=='workflowManagement',active:activeTabIs=='workflowManagement'}" v-if="isRoleAdmin" role="tabpanel" aria-labelledby="tab-tab" id="workflowManagement">
                            <workflowManagement/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './header.vue'
import userManager from './userManager.vue'
import addCustomField from './addCustomField.vue'
import emailSettings from './emailSettings.vue'
import systemRestore from './systemRestore'
import auditRecord from './auditRecord'
import downloadBackup from './downloadBackup'
import editPersonalSettings from './editPersonalSettings'
import changePassword from './changePassword'
import generalCompanySettings from './generalCompanySettings'
import workflowManagement from './workflowManagement'
import bidTemplates from './bidTemplates'
import callCenterSettings from './callCenterSettings'
import thirdPartySettings from './thirdPartySettings'

import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import AuditRecord from './auditRecord.vue'
import BidTemplates from './bidTemplates.vue'
import documentManagement from './documentManagement.vue'
import calendarManagement from './calendarManagement.vue'
export default {
  name: 'Settings',
  components: {
      Header,
        "user-manager":userManager,
        "add-customField":addCustomField,
        "email-settings":emailSettings,
        systemRestore,
        auditRecord,
        downloadBackup,
        editPersonalSettings,
        changePassword,
        generalCompanySettings,
        AuditRecord,
        workflowManagement,
        bidTemplates,
        BidTemplates,
        documentManagement,
        callCenterSettings,
        thirdPartySettings,
        calendarManagement
    },
    computed: {
        ...mapState(['baseUrl','windowWidth','maxMobilSize','maxTabletSize']),
    },
    data () {
        return{
            user:{},
            users:[],
            ram:"",
            activeTabIs:'',
            isRoleAdmin:true
        }
    },
    methods:{
        setActiveTabAs(tab){
        if(this.$route.query.paymentStatus){
            this.activeTabIs = "userManagement"
        }
        else
           
            this.activeTabIs = tab
        },
        isActive(){
             
            axios({
                method:'POST',
                url:'/getUsers',
                baseURL: this.baseUrl,
                data: {
                    showPassiveUsers:true
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.user=res.data.content.user
                        this.users=res.data.content.users
                        if(this.user.userRoleId!==1){
                            this.isRoleAdmin=false
                            this.setActiveTabAs('emailSettings')
                        }
                        this.$refs.usermanager.accountCount=this.users.length
                         
                    }
                    else{
                         
                    }
                }else{
                    this.$router.go(-1)
                }
            })
        },
        upToggle(id){
            if(this.windowWidth<this.maxMobilSize){
                $("#"+id).slideUp();
            }
        },
        toggleClick(id){
            if(this.windowWidth<this.maxMobilSize){
                $("#"+id).slideToggle();
                
            }
        },
        ...mapActions([
            'updateLoading'
        ]),

    },
    mounted(){
        this.isActive()
        if(this.windowWidth<this.maxMobilSize){
            this.upToggle('settingsTabMenu')
        }
        if(document.querySelector(".modal-backdrop")){
            document.querySelector(".modal-backdrop").style.display="none";
        }
        
    },
    created(){
        if(this.$route.query.tab=="email_settings"){
            console.log("email")
            this.setActiveTabAs('emailSettings')
        }
        else if(this.$route.query.tab=="documentManagementSettings"){
            this.setActiveTabAs('documentManagementSettings')
        }
        else if(this.$route.query.tab=="callCenterSettings"){
            this.setActiveTabAs('callCenterSettings')
        }
        else if(this.$route.query.tab=="thirdPartySettings"){
            this.setActiveTabAs('thirdPartySettings')
        }
        else if(this.$route.query.tab=="generalCompanySettings"){
            this.setActiveTabAs('generalCompanySettings')
        }
        else if(this.$route.query.tab=="userManagement"){
            this.setActiveTabAs('userManagement')
        }
        else if(this.$route.query.tab=="auditPage"){
            this.setActiveTabAs('auditPage')
        }
        else if(this.$route.query.tab=="workflowManagement"){
            this.setActiveTabAs('workflowManagement')
        }
        else if(this.$route.query.tab=="calendarManagement"){
            this.setActiveTabAs('calendarManagement')
        }
        else{
            console.log("editPersonalSettings")
            this.setActiveTabAs('editPersonalSettings')
        }
        if(this.$route.query.paymentStatus){
            console.log("userManagement")
            this.setActiveTabAs('userManagement')
        }
        this.$root.$refs.Settings = this
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.settingsMenu{
    border-radius: 4px;
    overflow: hidden;
    border: 0.5px solid #AFC2D9;
}
.settingsMenu .active button{
    background: #3c89d8 !important;
    color: #FFF !important;
}
.settingsMenu button{
    color: #93959A;
    line-height: 27px;
    border-radius: 0;
}

.settingsMenu button{
    background: #F7FAFD;
}
.settingsMenuDropTitle{
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    background: #1991EB;
    color: #FFF;
    padding: 0.8rem 1rem;
    border-radius: 4px;
}
.pageTitleDiv{
        background-color: #fff;
        /* position: sticky; */
        top: 60px;
        z-index: 99;
}    
.pageTitleDiv2{
        display: none;
}
@media (max-width: 992px){
        .pageTitleDiv{
        display: initial;
    }
    .pageTitle{
        margin-bottom: 0 !important;
    }
        .pageTitleDiv2{
       display: inline-block;
       
    }
    .mt-5{
        margin-top: 1.5rem !important;
    }
}
@media (max-width:768px){
    #settingsTabMenu{
        position: absolute;
        z-index: 98;
        box-shadow: 2px 2px 10px;
        max-width: 540px !important;
        display: block;
        width: 100%;
    }
}
</style>
